import {
  APPLY_X10_CONFIG,
  APPLY_X10_CONFIG_ERROR,
  APPLY_X10_CONFIG_SUCCESS,
  GET_X10_CONFIG,
  GET_X10_CONFIG_ERROR,
  GET_X10_CONFIG_HISTORY,
  GET_X10_CONFIG_HISTORY_SUCCESS,
  GET_X10_CONFIG_SUCCESS,
  IApplyX10ConfigAction,
  IApplyX10ConfigErrorAction,
  IApplyX10ConfigSuccessAction,
  IGetX10ConfigAction,
  IGetX10ConfigErrorAction,
  IGetX10ConfigHistoryAction,
  IGetX10ConfigHistorySuccessAction,
  IGetX10ConfigSuccessAction,
  IPingX10Action,
  IPingX10DoneAction,
  IStartX10ConfigPollingAction,
  IStopX10ConfigPollingAction,
  IX10ConfigBlocked,
  IX10ConfigCommand,
  IX10ConfigPingResult,
  IX10Configuration,
  IX10ConfigurationUpdate,
  PING_X10,
  PING_X10_DONE,
  START_X10_CONFIG_POLLING,
  STOP_X10_CONFIG_POLLING
} from "./types";

/** Pings the unit, then keeps its configuration state fresh until {@link stopX10ConfigPolling}. */
export const startX10ConfigPolling = (x10Id: string): IStartX10ConfigPollingAction => ({
  type: START_X10_CONFIG_POLLING,
  payload: x10Id
});

export const stopX10ConfigPolling = (): IStopX10ConfigPollingAction => ({
  type: STOP_X10_CONFIG_POLLING
});

export const getX10Config = (x10Id: string): IGetX10ConfigAction => ({
  type: GET_X10_CONFIG,
  payload: x10Id
});

export const getX10ConfigSuccess = (
  configuration: IX10Configuration
): IGetX10ConfigSuccessAction => ({
  type: GET_X10_CONFIG_SUCCESS,
  payload: configuration
});

export const getX10ConfigError = (): IGetX10ConfigErrorAction => ({
  type: GET_X10_CONFIG_ERROR
});

export const getX10ConfigHistory = (x10Id: string): IGetX10ConfigHistoryAction => ({
  type: GET_X10_CONFIG_HISTORY,
  payload: x10Id
});

export const getX10ConfigHistorySuccess = (
  x10Id: string,
  history: IX10ConfigCommand[]
): IGetX10ConfigHistorySuccessAction => ({
  type: GET_X10_CONFIG_HISTORY_SUCCESS,
  payload: { x10Id, history }
});

export const pingX10 = (x10Id: string): IPingX10Action => ({
  type: PING_X10,
  payload: x10Id
});

export const pingX10Done = (result: IX10ConfigPingResult | null): IPingX10DoneAction => ({
  type: PING_X10_DONE,
  payload: result
});

export const applyX10Config = (
  x10Id: string,
  update: IX10ConfigurationUpdate
): IApplyX10ConfigAction => ({
  type: APPLY_X10_CONFIG,
  payload: { x10Id, update }
});

export const applyX10ConfigSuccess = (
  x10Id: string,
  command: IX10ConfigCommand
): IApplyX10ConfigSuccessAction => ({
  type: APPLY_X10_CONFIG_SUCCESS,
  payload: { x10Id, command }
});

export const applyX10ConfigError = (
  blocked: IX10ConfigBlocked | null
): IApplyX10ConfigErrorAction => ({
  type: APPLY_X10_CONFIG_ERROR,
  payload: blocked
});
